import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { type ApiGameDetails, getGameById } from "../../../api";

export function useCurrentGameQuery(
  options?: Omit<UseQueryOptions<ApiGameDetails>, "queryKey" | "queryFn">,
) {
  const gameId = useCurrentGameId();

  return useQuery({
    queryKey: ["game", gameId],
    queryFn: () => getGameById(gameId),
    enabled: !!gameId,
    ...options,
  });
}

export function useCurrentGameId() {
  const { gameId = "" } = useParams<{ gameId: string }>();

  return gameId;
}
